import state from "./moduleBanksState";
import mutations from "./moduleBanksMutations";
import actions from "./moduleBanksActions";
import getters from "./moduleBanksGetters";

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};
